import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import { countries } from "utils";

const DirectorUBO = ({
  type,
  handleAdd,
  handleRemove,
  data,
  handleChangePeopleName,
  handleChangePeopleCountry
}) => {
  return (
    <Box
      sx={{
        border: "1px solid #eee",
        borderRadius: 2,
        p: 3,
        height: "100%"
      }}
    >
      <Grid container spacing={2}>
        {data.map((item, index) => (
          <React.Fragment key={item.id}>
            {/* Name */}
            <Grid item xs={5}>
              <TextField
                fullWidth
                label="Name"
                onChange={(ev) =>
                  handleChangePeopleName(ev, type, index)
                }
              />
            </Grid>

            {/* Country */}
            <Grid item xs={5}>
              <Autocomplete
                options={countries}
                autoHighlight
                getOptionLabel={(option) => option?.label || ""}
                onChange={(ev, val) =>
                  handleChangePeopleCountry(ev, val, type, index)
                }
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    <img
                      loading="lazy"
                      width="20"
                      src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                      alt=""
                      style={{ marginRight: 8 }}
                    />
                    {option.label} ({option.code})
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Country" />
                )}
              />
            </Grid>

            {/* Remove */}
            <Grid
              item
              xs={2}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {data.length > 1 && (
                <IconButton
                  size="small"
                  onClick={() => handleRemove(type, item.id)}
                  sx={{
                    opacity: 0.4,
                    "&:hover": { opacity: 1, color: "error.main" }
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              )}
            </Grid>
          </React.Fragment>
        ))}

        <Grid item xs={10}>
          <Button
            variant="outlined"
            fullWidth
            sx={{ mt: 1 }}
            onClick={handleAdd}
          >
            Add {type.toUpperCase()}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};


export default DirectorUBO;
